import { createLazyComponent } from '@muse-web/router'

import { useActiveAudio } from '../hooks/useActiveAudio'

const AudioPlayer = createLazyComponent(
    () => import(/* webpackChunkName: 'audio-player' */ './AudioPlayerContainer'),
    'AudioPlayerContainer',
)

export const AsyncAudioPlayerContainer = () => {
    const audio = useActiveAudio()

    if (!audio) return null

    return <AudioPlayer audio={audio} />
}
